import { render, staticRenderFns } from "./ApexChart.vue?vue&type=template&id=5bece892&"
import script from "./ApexChart.vue?vue&type=script&lang=js&"
export * from "./ApexChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexChart.vue?vue&type=style&index=0&id=5bece892&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports